import React from 'react';
import Modal from '../../../components/ui/Modal/Modal';
import MultiSelect from '../../../components/ui/MultiSelect/MultiSelect';
import Button from '../../../components/ui/Button/Button';
import { LoadsFilters, EMPTY_FILTERS, LoadsFilterOptions, showsClientFilter } from '../loadsFilters';

interface FiltersModalProps {
  open: boolean;
  onClose: () => void;
  /**
   * Opciones de cada menú.
   *
   * 📌 Llegan por props en lugar de derivarse de las cargas visibles. Antes se derivaban
   * (`deriveFilterOptions(loads)`), que funcionaba solo porque la pantalla traía todas: con
   * paginación del lado del servidor el menú listaría únicamente los valores de la página actual, o
   * sea que no se podría filtrar por nada que no estuviera ya a la vista.
   */
  options: LoadsFilterOptions;
  filters: LoadsFilters;
  onApply: (filters: LoadsFilters) => void;
}

const FiltersModal: React.FC<FiltersModalProps> = ({
  open,
  onClose,
  options,
  filters,
  onApply,
}) => {
  const [draft, setDraft] = React.useState<LoadsFilters>(filters);

  // Sincroniza el draft al abrir
  React.useEffect(() => {
    if (open) setDraft(filters);
  }, [open, filters]);

  const set = (key: keyof LoadsFilters) => (values: string[]) =>
    setDraft((d) => ({ ...d, [key]: values }));

  return (
    <Modal
      open={open}
      title="Filters"
      onClose={onClose}
      footer={
        <>
          <Button variant="ghost" onClick={() => setDraft(EMPTY_FILTERS)}>
            Clear
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              onApply(draft);
              onClose();
            }}
          >
            Aplicar
          </Button>
        </>
      }
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <MultiSelect
          label="Month"
          options={options.months}
          selected={draft.months}
          onChange={set('months')}
        />
        {/**
         * 🔄 19-oct-2026: clientes, solo para quien tiene cargas de más de uno (*"nos falta uno de clientes si tienen mas
         * de un cliente asignado"*). Después del mes, el mismo lugar que en el modal de marítimo y aéreo.
         */}
        {showsClientFilter(options) && (
          <MultiSelect
            label="Client"
            options={options.clients}
            selected={draft.clients}
            onChange={set('clients')}
          />
        )}
        <MultiSelect
          label="Office"
          options={options.offices}
          selected={draft.offices}
          onChange={set('offices')}
        />
        <MultiSelect
          label="Carrier"
          options={options.carriers}
          selected={draft.carriers}
          onChange={set('carriers')}
        />
        <MultiSelect
          label="Operation Type"
          options={options.operationTypes}
          selected={draft.operationTypes}
          onChange={set('operationTypes')}
        />
        <MultiSelect
          label="Mode"
          options={options.modes}
          selected={draft.modes}
          onChange={set('modes')}
        />
      </div>
    </Modal>
  );
};

export default FiltersModal;
